/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Update_CheckInputs */

const en_us2_profile_update_check = /** @type {(inputs: Profile_Update_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check for updates`)
};

const pt_br2_profile_update_check = /** @type {(inputs: Profile_Update_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procurar atualizações`)
};

const es_419_profile_update_check = /** @type {(inputs: Profile_Update_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar actualizaciones`)
};

const pt_pt2_profile_update_check = /** @type {(inputs: Profile_Update_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procurar atualizações`)
};

const fr_fr2_profile_update_check = /** @type {(inputs: Profile_Update_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher des mises à jour`)
};

const de_de2_profile_update_check = /** @type {(inputs: Profile_Update_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach Updates suchen`)
};

const it_it2_profile_update_check = /** @type {(inputs: Profile_Update_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca aggiornamenti`)
};

/**
* | output |
* | --- |
* | "Check for updates" |
*
* @param {Profile_Update_CheckInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_update_check = /** @type {((inputs?: Profile_Update_CheckInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Update_CheckInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_update_check(inputs)
	if (locale === "es-419") return es_419_profile_update_check(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_update_check(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_update_check(inputs)
	if (locale === "de-DE") return de_de2_profile_update_check(inputs)
	if (locale === "it-IT") return it_it2_profile_update_check(inputs)
	return en_us2_profile_update_check(inputs)
});
export { profile_update_check as "profile.update_check" }